import { render, staticRenderFns } from "./solicitacaoIdenizatoriaProcurador.vue?vue&type=template&id=5c7e4938&scoped=true&"
import script from "./solicitacaoIdenizatoriaProcurador.vue?vue&type=script&lang=js&"
export * from "./solicitacaoIdenizatoriaProcurador.vue?vue&type=script&lang=js&"
import style0 from "./solicitacaoIdenizatoriaProcurador.vue?vue&type=style&index=0&id=5c7e4938&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7e4938",
  null
  
)

export default component.exports